module.exports = __webpack_public_path__ + "img/timeline_bg_animated.d16ad2d1.svg";